import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import Header from "./components/Header";

/*import logo from "../img/illuminarium.png";*/
import pdfImage from "../img/pdf-icon.png";

const Step50_Confirmation = () => {
    const [resources, setResources] = useState({});
    const [order, setOrder] = useState({});
    const [organizerId, setOrganizerId] = useState("");

    const [error, setError] = useState(null);

    const [token] = useState(sessionStorage.getItem("token"));

    // fetching resources
    const { language, orderId } = useParams();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
        requestResources();
        requestFormSettings();
    }, [language]);

    useEffect(() => {
        // Fire Meta Pixel Purchase event when order is loaded and valid
        if (order && order.invoiceNumber && !error) {
            if (window.fbq) {
                window.fbq('track', 'Purchase', {
                    value: order.totalPrice || 0,
                    currency: 'CHF',
                    order_id: order.invoiceNumber
                });
            }
        }
    }, [order, error]);

    const requestFormSettings = () => {
        axios.get(`form/formsettings`).then((res) => {
            setOrganizerId(res.data.organizerId);
            loadOrder(orderId);
        });
    };

    const requestResources = () => {
        axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data);
            })
            .catch((error) => console.log(error.response.data));
    };

    const loadOrder = async (orderId, attempt = 1) => {
        try {
            const fetchedOrder = await getOrderByOrderId(orderId);

            // If invoiceNumber missing and attempts < 3, retry
            if ((!fetchedOrder?.invoiceNumber || fetchedOrder.invoiceNumber === "") && attempt < 7) {
                console.log(`Retrying to fetch order... Attempt ${attempt + 1}`);
                await new Promise((resolve) => setTimeout(resolve, 2000)); // optional delay before retry
                return loadOrder(orderId, attempt + 1);
            }

            if (!fetchedOrder?.invoiceNumber) {
                setError("Invoice number is missing after multiple attempts.");
            } else {
                setError(null);
            }

            const totalPrice = order.totalPrice;

            setOrder(fetchedOrder);
        } catch (error) {
            console.error(error);
            setError("Failed to load order.");
        }
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const getPdfTicketsOfOrder = async () => {
        await axios
            .get(
                `${baseUrl}/Order/${orderId}/TicketsPdf?organizerId=${organizerId}`,
                {
                    responseType: "blob",
                }
            )
            .then((res) => {
                const data = window.URL.createObjectURL(res.data);
                var link = document.createElement("a");
                link.href = data;
                link.download = "Tickets.pdf";
                link.click();
            })
            .catch((error) => console.log(error.response.data));
    };

    return (
        <>
            <Header />
            <div className="container">
                {resources.translation && (
                    <div className="row">

                        {/* Show error message if any */}
                        {/*{error && (*/}
                        {/*    <div className="col-md-6 mt-5 ">*/}
                        {/*        <div className="alert alert-danger" role="alert">*/}
                        {/*            <p dangerouslySetInnerHTML={{ __html: resources?.translation?.ErrorOrder?.replaceAll("${orderId}", orderId) }}></p>*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*)}*/}

                        {!error && order && order.invoiceNumber && order.invoiceNumber !== 0 && (
                        <>
                            <div className="offset-md-3 col-md-6 text-center">

                                <div className="m-5">
                                    <div className="row">
                                        <div className="col-md-12 mb-2">
                                            <h1>
                                                Vielen Dank!🎉
                                            </h1>
                                        </div>
                                    </div>
                                    <div className="mt-4">
                                        <div className="row">
                                            <div className="col-md-12 ">
                                                <p>Deine Bestell-Nr. lautet {order.invoiceNumber && order.invoiceNumber}</p>
                                                <p>
                                                    Deine Bestellung wurde erfolgreich abgeschlossen.
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row mt-4">
                                            <div className="col-md-12">
                                                <button
                                                    className="custom-button form-control pdf-button"
                                                    onClick={() => getPdfTicketsOfOrder()}
                                                >
                                                    TICKET HERUNTERLADEN
                                                </button>
                                            </div>
                                        </div>

                                        <div className="row mt-5">
                                            <div className="col-md-12 ">
                                                <p>
                                                    Deine Tickets solltest du in Kürze per Mail erhalten.
                                                </p>
                                            </div>
                                        </div>

                                        <div className="row mt-5">
                                            <div className="col-md-12 ">
                                                <hr />
                                            </div>
                                        </div>

                                        <div className="row mt-5">
                                            <div className="col-md-12 ">
                                                <p>
                                                    Für technische Fragen rund ums Ticketing wie Bezahlung, Rechnungserstattung etc. kannst du dich direkt bei TICKETINO unter <a href="mailto:info@ticketino.com">info@ticketino.com</a> melden.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p className="mt-5 text-center">
                                    {resources.translation && (
                                        <small style={{ color: 'grey' }}>powered by <a style={{ color: 'grey' }} href={resources.translation._TicketinoOrganizerUrl} target="_blank">TICKETINO</a></small>
                                    )}
                                </p>
                            </div>
                        </>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default Step50_Confirmation;
